//-----------------
// is rune changed
//-----------------
export default function isRuneChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isRuneChanged')

  console.log('ORIGINAL RUNE: ', original)
  console.log('NOW RUNE: ', now)

  if (
    original.strength != now.strength ||
    original.pwr_storage != now.pwr_storage ||
    original.starter != now.starter ||
    original.integrated != now.integrated ||
    original.active != now.active ||
    original.character_item != now.character_item ||
    original.notes != now.notes
  ) {
    console.log('VALUE CHANGED ', original.name)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.name)
    return false
  }
}
